/**
 * Color swatch click handler for iurop-product-card.
 *
 * On click, instead of navigating to the swatched product's PDP, fetches that
 * product's card markup via the Section Rendering API and replaces the
 * current card in place. This keeps EVERY piece of state (image, hover image,
 * title, price, quick-add variant ids, size buttons, active swatch) in sync
 * with the swatched product.
 *
 * Section endpoint: /products/{handle}?section_id=api-product-card
 */
(function () {
  var SECTION_ID = 'api-product-card';
  var inflight = new WeakMap();

  function rebuildCard(card, html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html.trim();
    // Section API wraps content in <div id="shopify-section-..."> — find the article inside.
    var newCard = tmp.querySelector('[data-product-card]');
    if (!newCard) return;
    card.replaceWith(newCard);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-card-swatch]');
    if (!link) return;

    var card = link.closest('[data-product-card]');
    if (!card) return;

    // Allow modifier-clicks and middle/right click to behave normally
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    var handle = link.getAttribute('data-handle');
    if (!handle) return;

    e.preventDefault();

    // Cancel any pending fetch for this card
    var prev = inflight.get(card);
    if (prev) prev.abort();
    var ctrl = new AbortController();
    inflight.set(card, ctrl);

    // Optimistic UX: mark this swatch active immediately
    card.querySelectorAll('[data-card-swatch] .product-swatches__swatch-content').forEach(function (s) {
      s.classList.remove('active');
    });
    var content = link.querySelector('.product-swatches__swatch-content');
    if (content) content.classList.add('active');

    fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID, {
      signal: ctrl.signal,
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        rebuildCard(card, html);
        inflight.delete(card);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Fallback: navigate to the product page
        console.error('[card-swatch] fetch failed, falling back to navigation', err);
        window.location.href = '/products/' + handle;
      });
  });
})();
